
//
// Landing page explaining the compliance policy. Deliberately a constant and not a translation
// resource: the address is the same in every language and must never end up in a translation memory.
//
export const COMPLIANCE_URL = 'https://go.invantive.com/compliance';
